<template>
  <div class="top-area">
    <h3 style="color: #fff">Tasu</h3>
    <div class="flex-1"></div>
    <div class="top-item">
      <a-dropdown>
        <div class="align-center pointer" @click.prevent>
          <span style="margin-right: 3px">
            <span v-if="langTag == 'kz'">Қазақша</span>
            <span v-if="langTag == 'rus'">Русский</span>
            <span v-if="langTag == 'en'">English</span>
          </span>
          <span style="font-size: 18px" class="material-symbols-outlined">
            language
          </span>
        </div>
        <template #overlay>
          <a-menu>
            <a-menu-item>
              <a
                :style="{ color: langTag == 'kz' ? '#40a9ff' : '#000' }"
                href="#"
                @click="setLanguage('kz')"
                >Қазақша</a
              >
            </a-menu-item>
            <a-menu-item>
              <a
                :style="{ color: langTag == 'rus' ? '#40a9ff' : '#000' }"
                href="#"
                @click="setLanguage('rus')"
                >Русский</a
              >
            </a-menu-item>
            <a-menu-item>
              <a
                :style="{ color: langTag == 'en' ? '#40a9ff' : '#000' }"
                href="#"
                @click="setLanguage('en')"
                >English</a
              >
            </a-menu-item>
          </a-menu>
        </template>
      </a-dropdown>
    </div>
    <div class="top-item">
      <a-dropdown
        v-model:visible="isDropdownVisible"
        placement="bottomRight"
        trigger="click"
      >
        <span
          class="material-symbols-outlined"
          style="cursor: pointer"
          @click="toggleDropdown"
        >
          notifications
        </span>
        <template #overlay>
          <div
            style="
              width: 400px;
              padding: 15px;
              background: white;
              border: #f1f1f1 solid 2px;
              border-radius: 15px;
            "
            @click.stop
          >
            <div v-if="messageList.length === 0">
              <h3>{{ $t("l_There_is_nothing") }}</h3>
            </div>
            <div
              v-else
              style="max-height: 800px; overflow-y: auto; padding-right: 8px"
              class="scrollable-content"
            >
              <a-menu>
                <h2 style="margin-left: 10px">{{ $t("l_Notification") }}</h2>
                <a-menu-item v-for="(item, index) in messageList" :key="index">
                  <div class="card">
                    <div style="display: flex; justify-content: space-between">
                      <h2>{{ item.subject }}</h2>
                      <a-checkbox
                        :value="item.id"
                        @change="onCheckboxChange(item.id, $event)"
                      ></a-checkbox>
                    </div>
                    <div v-html="sanitizeHtml(item.content)"></div>
                    <div
                      style="
                        width: 100%;
                        height: 2px;
                        background-color: #f1f1f1;
                      "
                    ></div>
                  </div>
                </a-menu-item>
              </a-menu>
            </div>
          </div>
        </template>
      </a-dropdown>
    </div>
    <div class="top-item">
      <div class="align-center pointer">
        <a-dropdown
          v-model:visible="isTaskVisible"
          placement="bottomRight"
          trigger="click"
        >
          <span
            class="material-symbols-outlined"
            style="cursor: pointer"
            @click="getTasks()"
          >
            event_note
          </span>
          <template #overlay>
            <div
              style="
                width: 400px;
                padding: 15px;
                background: white;
                border: #f1f1f1 solid 2px;
                border-radius: 15px;
              "
              @click.stop
            >
              <div v-if="taskList.length === 0">
                <h3>{{ $t("l_Empty") }}</h3>
              </div>
              <div
                v-else
                style="max-height: 800px; overflow-y: auto; padding-right: 8px"
                class="scrollable-content"
              >
                <a-menu>
                  <h2 style="margin-left: 10px">{{ $t("l_Tasks") }}</h2>
                  <a-menu-item v-for="(item, index) in taskList" :key="index">
                    <div class="card">
                      <div
                        @click="getTask(item.id)"
                        :style="{
                          display: 'flex',
                          justifyContent: 'space-between',
                          color:
                            item.taskStatus === 'SUCCESS' ? 'green' : 'red',
                        }"
                      >
                        <h2 style="font-size: 12px">
                          {{ item.taskName }}
                        </h2>
                        <div style="display: flex">
                          <p style="margin-right: 5px">
                            ({{ $timeFormat(item.createdAt, 1) }})
                          </p>
                          <span class="icon material-symbols-outlined">
                            download
                          </span>
                        </div>
                      </div>

                      <div
                        style="
                          width: 100%;
                          height: 2px;
                          background-color: #f1f1f1;
                        "
                      ></div>
                    </div>
                  </a-menu-item>
                </a-menu>
              </div>
            </div>
          </template>
        </a-dropdown>
      </div>
    </div>
    <div class="top-item" v-if="hasLogin">
      <a-dropdown>
        <div class="align-center pointer" @click.prevent>
          <span v-if="userInfo.user">{{ userInfo.user.name }}</span>
          <span class="material-symbols-outlined"> person </span>
        </div>
        <template #overlay>
          <a-menu>
            <a-menu-item @click="signOut()">
              <span class="pointer">
                {{ $t("l_Sign_out") }}
              </span>
            </a-menu-item>
          </a-menu>
        </template>
      </a-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import config from "@/config/index.js";
import DOMPurify from "dompurify";
// import { message } from "ant-design-vue";
//import { notification } from "ant-design-vue";
import { NotificationApi } from "@/api/notification";
import { AllApi } from "@/api/all";
import { FileApi } from "@/api/file";
//import { h } from "vue";
//import HtmlContent from "@/components/HtmlContent.vue";

export default {
  components: {},
  data() {
    return {
      connections: null,
      userId: null,
      baseUrl: config.baseURL,
      isDropdownVisible: false,
      messageList: [],
      isTaskVisible: false,
      taskList: [],
    };
  },
  computed: {
    ...mapGetters({
      hasLogin: "hasLogin",
      userInfo: "userInfo",
    }),
    langTag() {
      return this.$i18n.locale;
    },
  },
  created() {
    // if (this.userInfo && this.userInfo.userInfo) {
    //   this.userId = this.userInfo.userInfo.id;
    //   this.connections = new WebSocket(
    //     `ws://91.215.137.102/api/ws/notifications?userId=${this.userInfo.userInfo?.id}`
    //   );
    //   this.connections.onopen = () => {
    //     console.log("WebSocket connected!");
    //   };
    //   this.connections.onmessage = (event) => {
    //     const data = JSON.parse(event.data); // Parse event data
    //     if (data && data.subject && data.content) {
    //       //   const sanitizedContent = this.sanitizeHtml(data.content);
    //       // notification.open({
    //       //   message: data.subject,
    //       //   description: () => h(HtmlContent, { content: sanitizedContent }),
    //       //   duration: 0,
    //       // });
    //       const message = { remindId: data.id, RemindStatus: "RECEIVED" };
    //       this.sendMessage(message);
    //       console.log("message.sended");
    //     } else {
    //       console.error("Invalid message format:", data);
    //     }
    //   };
    //   this.connections.onclose = () => {
    //     console.log(
    //       "WebSocket closed. Please check the server or connection settings."
    //     );
    //   };
    //   this.connections.onerror = (error) => {
    //     console.error("WebSocket error:", error);
    //   };
    // }
  },

  mounted() {
    if (this.hasLogin) {
      this.getMessages();
    }
  },
  unmounted() {
    this.beforeDestroy();
  },
  methods: {
    ...mapMutations({
      signOut: "signOut",
    }),
    toggleDropdown() {
      this.isDropdownVisible = !this.isDropdownVisible;
    },
    setLanguage(e) {
      this.$i18n.locale = e;
      localStorage.setItem("currentLang", e);
    },
    onCheckboxChange(id, event) {
      if (event.target.checked) {
        const message = { remindId: id, RemindStatus: "READ" };
        this.sendMessage(message);
        console.log("Checkbox clicked, message sent:", message);
      }
    },
    sendMessage(message) {
      if (this.connections && this.connections.readyState === WebSocket.OPEN) {
        console.log(message);
        this.connections.send(JSON.stringify(message));
      } else {
        console.error("WebSocket 未连接");
      }
    },
    getTasks() {
      AllApi("tasks", {}, "GET").then((res) => {
        if (res.code == 0) {
          this.taskList = res.data;
          this.isTaskVisible = true;
        }
      });
    },
    getTask(e) {
      AllApi("tasks/" + e, {}, "GET").then((res) => {
        if (res.code == 0) {
          let key = res.data?.resultContent;
          FileApi("temp?objectKey=" + key, {}, "GET").then((res) => {
            if (res.code == 0) {
              window.open(res.data);
            }
          });
        }
      });
    },
    sanitizeHtml(html) {
      return DOMPurify.sanitize(html);
    },
    beforeDestroy() {
      // 组件销毁前关闭 WebSocket 连接
      if (this.connections) {
        this.connections.close();
      }
    },
    getMessages() {
      NotificationApi("reminds", { page: 0, size: 100 }, "GET").then((res) => {
        if (res.code === 0) {
          this.messageList = JSON.parse(JSON.stringify(res.data.content));
          console.log("Messages:", this.messageList);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.top-area {
  display: flex;
  justify-content: space-around;
  padding: 3px 15px;
  align-items: center;
  background-color: #1c1c1c;
  color: #f1f1f1;
  min-height: 50px;
  .ant-dropdown-link {
    color: #000;
  }

  .top-item {
    margin-left: 20px;
  }
}
.card {
  margin-bottom: 20px;
}
.scrollable-content {
  max-height: 800px;
  overflow-y: auto;
  padding-right: 8px; /* Adjust for scrollbar */
}

/* Optional: Custom scroll styling */
.scrollable-content::-webkit-scrollbar {
  width: 8px;
}

.scrollable-content::-webkit-scrollbar-thumb {
  background-color: #d4d4d4;
  border-radius: 4px;
}

.scrollable-content::-webkit-scrollbar-thumb:hover {
  background-color: #aaa;
}
</style>
